import { useLocalSearchParams } from 'expo-router';
import { useEffect } from 'react';
import { KpLiveLessonSummaryView } from '@/components/kursi-play-v2/KpLiveLessonSummaryView';
import { trackKursiPlayEvent } from '@/utils/kursiPlayTelemetry';

export function RuntimeSummaryScreen() {
  const {
    slug,
    lessonId,
    uid,
    token,
    xp_earned,
    total_world_xp,
    streak_days,
    next_lesson_id,
    is_world_complete,
    freeze_awarded,
    streak_preserved,
    freeze_used,
  } = useLocalSearchParams<{
    slug: string;
    lessonId: string;
    uid: string;
    token?: string;
    xp_earned: string;
    total_world_xp: string;
    streak_days: string;
    next_lesson_id: string;
    is_world_complete: string;
    freeze_awarded: string;
    streak_preserved: string;
    freeze_used: string;
  }>();

  const userId = uid ?? '';
  const isGuest = !userId || userId.startsWith('guest_');
  const safeSlug = slug ?? '';
  const lessonCompleted = Number(xp_earned ?? 0) >= 0 && !!lessonId;
  const worldCompleted = is_world_complete === 'true';

  useEffect(() => {
    if (!userId || !safeSlug || !lessonCompleted) return;
    void trackKursiPlayEvent('learn_lesson_completed', { uid: userId, slug: safeSlug, lesson_id: lessonId });
    void trackKursiPlayEvent('learn_first_lesson_completed', { uid: userId, slug: safeSlug, lesson_id: lessonId });
    if (worldCompleted) {
      void trackKursiPlayEvent('learn_readiness_checkpoint', { uid: userId, slug: safeSlug, checkpoint: 'world_complete' });
    }
  }, [lessonCompleted, lessonId, safeSlug, userId, worldCompleted]);

  return (
    <KpLiveLessonSummaryView
      lessonId={lessonId ?? ''}
      slug={slug ?? ''}
      userId={userId}
      guestSessionToken={token ?? ''}
      xpEarned={Number(xp_earned ?? 0)}
      totalWorldXp={Number(total_world_xp ?? 0)}
      streakDays={Number(streak_days ?? 0)}
      nextLessonId={next_lesson_id || null}
      isWorldComplete={is_world_complete === 'true'}
      isGuest={isGuest}
      freezeAwarded={freeze_awarded === 'true'}
      streakPreserved={streak_preserved === 'true'}
      freezeUsed={freeze_used === 'true'}
    />
  );
}
